import { useState, useEffect } from 'react';
import { PotentialClient } from '../types/client';
import { mockPotentialClients } from '../data/mockPotentialClients';

export const usePotentialClients = () => {
  const [clients, setClients] = useState<PotentialClient[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchClients = async () => {
      setIsLoading(true);
      try {
        // Simuler un appel API
        await new Promise(resolve => setTimeout(resolve, 500));
        setClients(mockPotentialClients);
      } catch (error) {
        console.error('Failed to fetch potential clients:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchClients();
  }, []);

  return { clients, isLoading };
};